export default "__VITE_ASSET__CdcOSb$E__"